import React from 'react';

import { Text, Flex, rem } from '@vimeo/bokeh';
import { ThumbUpFilled } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createInteractionDomName } from '../../../../libs/shared/utils/dom/identifying';

interface IQuestionItemVotesCountProps extends IBaseDomElementProps {
  votesCount: number;
}

export function QuestionItemVotesCount({
  id = createInteractionDomName('question-manage-item-votes'),
  className = createInteractionDomName('question-manage-item-votes'),
  votesCount,
}: IQuestionItemVotesCountProps) {
  return (
    <Flex
      id={id}
      className={className}
      cursor={'default'}
      alignItems={'center'}
      justifyContent={'space-between'}
      gap={rem(4)}
    >
      <ThumbUpFilled boxSize={rem(16)} />
      <Text variant={'heading-xs'}>{votesCount}</Text>
    </Flex>
  );
}
